module.exports = __webpack_public_path__ + "0faa1074c17a74a7f5e32cbe6f9d76f3.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Thin.woff2
// module id = 1015
// module chunks = 0